module.exports = __webpack_public_path__ + "img/IMG_9621_L_BlackMatted.b6cc4f41.jpg";